import {Tooltip} from "@mui/material";

const CustomTooltip = ({title, children}) => {
    return <Tooltip arrow title={title}>
        {children}
    </Tooltip>
}

export default CustomTooltip